import algoliasearch from 'algoliasearch/lite';
import { fetchProductPageData } from "./product-loop";
import { triggerEvent } from "./functions";

let algoliaClient = {};

try {
  // eslint-disable-next-line no-undef
  algoliaClient = algoliasearch(translation.app_id, translation.frontend_key);
} catch (e) {
  console.warn(e.name, e.message);
  algoliaClient = {};
}

const searchClient = {
  ...algoliaClient, // push other clients fields to it (apiKey being the one needed for insights)

  search(requests) {
    if (requests.every(({ params }) => !params.query)) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
        })),
      });
    }

    return algoliaClient.search(requests);
  },
};

const mobileSearch = () => {
  const form = document.querySelector('#mobile-menu .search-form');
  if (form) {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      document.body.classList.toggle('open-mobile-menu');
      form.querySelector('.search-field').blur();
    });
  }
}
mobileSearch();


const boldString = (str, substr) => {
  const strRegExp = new RegExp(substr, 'g');
  return str.replace(strRegExp, `<strong>${substr}</strong>`);
}


const initSearchTab = () => {
  setTimeout(() => {
    const buttons = document.querySelectorAll('button.search-tab-button');
    if (buttons) {
      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const contentTabs = document.querySelectorAll('.search-tab-content');
          contentTabs.forEach((contentTab) => {
            contentTab.style.display = 'none';
          });
          // Remove old active
          document.querySelector('button.search-tab-button.active').classList.remove('active');

          // Add new active
          button.classList.add('active');

          document.getElementById(button.value).style.display = 'block';
        });
      });
    }
  }, 200)
}


const theSearchTwo = () => {
  const searchfields = Array.from(document.querySelectorAll('.search-form .search-field'));
  onkeydown = onkeyup = function (event) {
    if (event.key === '/') {
      event.preventDefault();
      searchfields[0].focus();
    }
  }

  let haveSearch = false;
  let isSearching = false;
  let backupContent = '';
  let wait = null;
  const originalLocation = window.location.href;
  const searchForm = document.querySelector('.header .search-form');
  const searchField = document.querySelector('.search-field');
  const searchSuggestionsElement = document.querySelector('.search-suggestions');

  searchForm.addEventListener('submit', (event) => {
    event.preventDefault();
  });

  searchForm.addEventListener('focusout', () => {
    setTimeout(() => {
      searchSuggestionsElement.innerHTML = '';
    }, 1000);
  });

  searchfields.forEach((searchfield) => {

    searchfield.addEventListener('input', (event) => {
      clearTimeout(wait);
      const mainContent = document.getElementById('main-content');
      if (!backupContent) {
        backupContent = mainContent.innerHTML;
      }

      if (searchfield.value.length > 0) {
        const querySuggestions = algoliaClient.initIndex('product_query_suggestions');
        querySuggestions.search(searchfield.value).then(({ hits }) => {
          searchSuggestionsElement.innerHTML = '';
          hits.forEach((hit) => {
            if (searchfield.value.toUpperCase() !== hit.query.toUpperCase()) {
              const liElement = document.createElement('li');
              const aElement = document.createElement('a');
              aElement.innerHTML = `${boldString(hit.query, searchfield.value)}`;
              aElement.href = '#';
              aElement.dataset.value = hit.query;
              liElement.appendChild(aElement);
              searchSuggestionsElement.appendChild(liElement);
              aElement.addEventListener('click', (event) => {
                event.preventDefault();
                searchfield.value = aElement.dataset.value;
                searchfield.dispatchEvent(new Event('input', { bubbles: true }));
                searchSuggestionsElement.innerHTML = '';
                searchfield.focus();
              })
            }
          });
        });
      } else {
        searchSuggestionsElement.innerHTML = '';
      }

      if (isSearching) {
        return;
      }

      if (searchfield.value.length > 2) {
        wait = setTimeout(() => {
          isSearching = true;
          const loadingHtml = document.createElement('div');
          const loadingText = document.createElement('span');
          const loadingIcon = document.createElement('div');
          const loadingIconInner = document.createElement('div');
          loadingHtml.id = 'maksimer-loading';
          loadingHtml.className = 'maksimer-loader';
          loadingIcon.className = 'loading-icon';
          loadingText.className = 'text';
          loadingText.innerText = 'Searching…';
          loadingIconInner.className = 'loading-icon-inner';
          loadingIcon.appendChild(loadingIconInner);
          loadingHtml.appendChild(loadingIcon);
          loadingHtml.appendChild(loadingText);

          let languageCode = document.querySelector('#language-selector select[name="language"]');

          if (languageCode) {
            languageCode = `${languageCode.value}-`;
          } else {
            languageCode = 'no-'
          }

          const queries = [
            {
              indexName: `${languageCode}product_cat`,
              query: searchfield.value,
              params: {
                hitsPerPage: 20
              }
            },
            {
              indexName: `${languageCode}product`,
              query: searchfield.value,
              params: {
                hitsPerPage: 30
              }
            },
            {
              indexName: `${languageCode}post`,
              query: searchfield.value,
              params: {
                hitsPerPage: 20
              }
            },
            {
              indexName: `${languageCode}page`,
              query: searchfield.value,
              params: {
                hitsPerPage: 20
              }
            },
            {
              indexName: `${languageCode}video`,
              query: searchfield.value,
              params: {
                hitsPerPage: 20
              }
            },
            {
              indexName: `${languageCode}faq`,
              query: searchfield.value,
              params: {
                hitsPerPage: 20
              }
            }
          ];


          mainContent.innerHTML = '';
          mainContent.appendChild(loadingHtml);

          algoliaClient.multipleQueries(queries).then(({ results }) => {
            const payload = {
              action: 'maksimer_algolia_search_result',
              searchWord: searchfield.value,
              results };
            const contentLang = document.language_selector.language.value
            const shippingLang = document.language_selector.shipping_country.value
            const link = `${translation.site_url}/${contentLang}-${shippingLang}/sok/?search=${searchfield.value}`
            // const link = `${translation.site_url}/sok/?search=${searchfield.value}`
            window.history.pushState({}, '', link);

            jQuery.post(translation.ajaxurl, payload, (result) => {
              mainContent.innerHTML = result;
              document.body.classList.add('search-result-page');
              haveSearch = true;
              isSearching = false;
              triggerEvent(document.body, 'search-result-updated');
              initSearchTab();
            });
          });
        }, 500);
      } else {
        if (haveSearch) {
          mainContent.innerHTML = backupContent
          window.dispatchEvent(new CustomEvent('scroll'))
          haveSearch = false;
          document.body.classList.remove('search-result-page');
          window.history.pushState({ html: backupContent }, '', originalLocation);
        }
      }
    });
  });


  if (document.body.dataset.postId == 2588960) {
    searchfields[0].dispatchEvent(new Event('input', { bubbles: true }));
  }
}
theSearchTwo();
window.addEventListener('maksimer_category_change', theSearchTwo);

if (document.body.classList.contains('tax-pa_utfordringer') || document.body.classList.contains('tax-pa_virkestoffer')) {
  initSearchTab()
}
